import { render, staticRenderFns } from "./btn-follow.vue?vue&type=template&id=1978d6b2&scoped=true&"
import script from "./btn-follow.vue?vue&type=script&lang=js&"
export * from "./btn-follow.vue?vue&type=script&lang=js&"
import style0 from "./btn-follow.vue?vue&type=style&index=0&id=1978d6b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1978d6b2",
  null
  
)

export default component.exports